/* eslint-disable react/prop-types */
import radiopYellow from '/radio-yellow.png'
export default function ProducerBubble({ producer }) {
  return (
    <div className="relative group w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden shadow-lg cursor-pointer transition-transform duration-300 ease-out hover:scale-110 hover:z-20 bubble-float">
      <img
        src={producer.img || radiopYellow} 
        alt={producer.name}
        className="w-full h-full object-cover rounded-full"
      />

      <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity rounded-full flex items-center justify-center text-yellow-cdg font-semibold text-center text-sm">
        {producer.name}
      </div>
    </div>
  );
}
